var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopLg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1257,
    height: 1025,
    viewBox: "0 0 1257 1025",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M538.036 266.372L469.644 305.805L308.205 212.148L379.069 172.715L538.036 266.372Z",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.036 474.646L469.644 514.079L308.205 420.421L379.069 380.988L538.036 474.646Z",
    stroke: "#231F20",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.654 474.646L469.249 514.079L307.811 420.421L378.675 380.988L537.654 474.646Z",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.646 305.806V514.079",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.683 172.715V380.988L308.268 420.349V212.088",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.039 265.689V473.963",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.728 383.448L256.323 422.881L94.8848 329.223L165.749 289.79L324.728 383.448Z",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.728 591.721L256.323 631.154L94.8848 537.496L165.749 498.063L324.728 591.721Z",
    stroke: "#231F20",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.331 591.721L255.939 631.154L94.5 537.496L165.364 498.063L324.331 591.721Z",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.322 422.881V631.154",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.361 289.79V498.063L94.957 537.424V329.163",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.729 382.764V591.037",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M974.124 370.515L905.732 409.948L744.293 316.291L815.157 276.846L974.124 370.515Z",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.124 578.777L905.732 618.222L744.293 524.552L815.157 485.119L974.124 578.777Z",
    stroke: "#231F20",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.742 578.777L905.349 618.222L743.898 524.552L814.762 485.119L973.742 578.777Z",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.734 409.948V618.222",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.771 276.846V485.119L744.367 524.492V316.219",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.127 369.831V578.092",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1186.07 488.022L1117.68 527.455L956.238 433.797L1027.09 394.353L1186.07 488.022Z",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.07 696.284L1117.68 735.729L956.238 642.059L1027.09 602.626L1186.07 696.284Z",
    stroke: "#231F20",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1185.69 696.284L1117.28 735.729L955.844 642.059L1026.71 602.626L1185.69 696.284Z",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1117.68 527.455V735.729",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1027.72 394.353V602.626L956.301 641.999V433.725",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.07 487.338V695.599",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M593.654 229.653L662.047 269.086L823.486 175.428L752.634 135.995L593.654 229.653Z",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.654 437.926L662.047 477.359L823.486 383.701L752.634 344.269L593.654 437.926Z",
    stroke: "#231F20",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.039 437.926L662.444 477.359L823.882 383.701L753.018 344.269L594.039 437.926Z",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.047 269.086V477.359",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.01 135.995V344.268L823.426 383.629V175.356",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.654 228.969V437.242",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M443.131 135.813L511.524 175.246L672.962 81.5882L602.11 42.1553L443.131 135.813Z",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.131 344.087L511.524 383.52L672.962 289.862L602.11 250.417L443.131 344.087Z",
    stroke: "#231F20",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.516 344.087L511.92 383.52L673.359 289.862L602.495 250.417L443.516 344.087Z",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.523 175.246V383.519",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.486 42.1553V250.417L672.902 289.79V81.5162",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.131 135.129V343.402",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M603.922 775.534L672.327 814.967L833.765 721.309L762.901 681.864L603.922 775.534Z",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.922 983.795L672.327 1023.24L833.765 929.571L762.901 890.138L603.922 983.795Z",
    stroke: "#231F20",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.316 983.795L672.709 1023.24L834.148 929.571L763.296 890.138L604.316 983.795Z",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.326 814.967V1023.24",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.289 681.864V890.138L833.693 929.511V721.237",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.922 774.85V983.111",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M469.646 682.117L538.039 721.562L699.478 627.892L628.626 588.459L469.646 682.117Z",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.646 890.39L538.039 929.823L699.478 836.165L628.626 796.732L469.646 890.39Z",
    stroke: "#231F20",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.031 890.39L538.436 929.823L699.875 836.165L629.01 796.732L470.031 890.39Z",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.039 721.562V929.823",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.002 588.459V796.732L699.418 836.093V627.832",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.646 681.433V889.706",
    stroke: "white",
    strokeWidth: 2.87919,
    strokeMiterlimit: 10
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.736 257.46L1226.04 844.275",
    stroke: "white",
    strokeWidth: 23.0695,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1085.27 775.018L867.911 900.334L354.852 602.686L580.04 477.357L1085.27 775.018Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.438 729.262L373.638 603.934",
    stroke: "white",
    strokeWidth: 23.0695,
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M524.961 560.098C521.77 559.187 519.37 558.515 516.743 557.771C521.674 549.745 526.448 541.948 531.427 533.85C528.884 533.214 526.784 532.686 524.337 532.062C528.944 523.497 533.454 515.111 538.157 506.342C535.29 505.922 532.915 505.574 529.711 505.106C539.921 490.698 545.835 474.587 551.989 457.611C558.395 474.395 563.986 490.662 574.483 505.094C571.268 505.55 568.832 505.898 565.893 506.318C570.596 515.003 575.095 523.329 579.797 532.026C577.482 532.614 575.395 533.142 572.635 533.838C577.59 541.888 582.413 549.733 587.379 557.795C584.668 558.551 582.269 559.211 579.138 560.086C585.412 569.024 591.446 577.614 598.044 587.031H558.539V618.114H545.679V587.259H505.91C512.568 577.77 518.603 569.168 524.961 560.098Z",
    fill: "white",
    stroke: "#716558",
    strokeWidth: 5.77038,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M790.533 638.484C788.373 637.872 786.754 637.416 784.978 636.912C788.313 631.478 791.54 626.223 794.899 620.741C793.184 620.309 791.756 619.949 790.101 619.541C793.208 613.747 796.267 608.072 799.446 602.146C797.503 601.858 795.907 601.63 793.736 601.306C800.634 591.565 804.641 580.672 808.791 569.203C813.122 580.552 816.901 591.541 824.003 601.306C821.832 601.618 820.176 601.846 818.197 602.134C821.376 608.012 824.411 613.639 827.59 619.517C826.019 619.913 824.615 620.273 822.755 620.741C826.102 626.187 829.366 631.49 832.725 636.936C830.889 637.44 829.27 637.896 827.158 638.484C831.405 644.53 835.472 650.336 839.947 656.694H813.242V677.713H804.545V656.85H777.66C782.159 650.432 786.238 644.614 790.545 638.484H790.533Z",
    fill: "white",
    stroke: "#716558",
    strokeWidth: 5.77038,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M896.894 789.881C894.735 789.269 893.115 788.813 891.339 788.31C894.675 782.875 897.902 777.621 901.261 772.138C899.545 771.706 898.118 771.346 896.462 770.938C899.569 765.144 902.628 759.47 905.807 753.543C903.864 753.255 902.268 753.027 900.097 752.704C906.995 742.962 911.002 732.069 915.153 720.601C919.484 731.949 923.262 742.938 930.364 752.704C928.193 753.015 926.538 753.243 924.558 753.531C927.737 759.41 930.772 765.036 933.951 770.914C932.38 771.31 930.976 771.67 929.117 772.138C932.464 777.585 935.727 782.887 939.086 788.334C937.251 788.837 935.631 789.293 933.52 789.881C937.766 795.927 941.833 801.734 946.308 808.092H919.604V829.11H910.906V808.248H884.021C888.52 801.83 892.599 796.011 896.906 789.881H896.894Z",
    fill: "white",
    stroke: "#716558",
    strokeWidth: 5.77038,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M478.702 579.232C475.067 578.2 472.344 577.433 469.357 576.581C474.971 567.439 480.406 558.574 486.068 549.349C483.177 548.617 480.79 548.017 477.994 547.321C483.237 537.568 488.371 528.019 493.734 518.037C490.471 517.558 487.772 517.162 484.113 516.622C495.725 500.21 502.479 481.868 509.474 462.541C516.767 481.652 523.138 500.174 535.086 516.61C531.427 517.126 528.644 517.522 525.309 518.001C530.66 527.899 535.782 537.376 541.133 547.273C538.493 547.945 536.118 548.545 532.975 549.337C538.613 558.502 544.108 567.428 549.758 576.617C546.675 577.469 543.94 578.236 540.377 579.22C547.515 589.405 554.389 599.183 561.911 609.896H516.923V645.286H502.276V610.147H456.988C464.57 599.338 471.444 589.537 478.69 579.22L478.702 579.232Z",
    fill: "white",
    stroke: "#716558",
    strokeWidth: 5.77038,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M725.579 590.354C721.944 589.322 719.221 588.555 716.234 587.703C721.848 578.562 727.283 569.696 732.945 560.471C730.054 559.739 727.667 559.139 724.871 558.443C730.114 548.69 735.248 539.141 740.611 529.159C737.348 528.68 734.649 528.284 730.99 527.744C742.602 511.333 749.356 492.99 756.35 473.663C763.644 492.774 770.015 511.296 781.963 527.732C778.304 528.248 775.521 528.644 772.186 529.123C777.537 539.021 782.659 548.498 788.01 558.395C785.37 559.067 782.995 559.667 779.852 560.459C785.49 569.624 790.985 578.55 796.635 587.739C793.552 588.591 790.817 589.359 787.254 590.342C794.392 600.527 801.266 610.305 808.788 621.018H763.8V656.408H749.152V621.27H703.865C711.447 610.461 718.321 600.659 725.567 590.342L725.579 590.354Z",
    fill: "white",
    stroke: "#716558",
    strokeWidth: 5.77038,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M839.896 822.045C836.261 821.013 833.537 820.245 830.55 819.393C836.165 810.252 841.599 801.386 847.262 792.161C844.37 791.429 841.983 790.829 839.188 790.134C844.43 780.38 849.565 770.831 854.927 760.85C851.664 760.37 848.965 759.974 845.306 759.434C856.919 743.023 863.673 724.68 870.667 705.354C877.961 724.464 884.331 742.987 896.28 759.422C892.621 759.938 889.837 760.334 886.502 760.814C891.853 770.711 896.975 780.188 902.326 790.086C899.687 790.757 897.311 791.357 894.168 792.149C899.807 801.314 905.301 810.24 910.952 819.429C907.868 820.281 905.133 821.049 901.57 822.033C908.708 832.218 915.582 841.995 923.104 852.708H878.117V888.098H863.469V852.96H818.182C825.764 842.151 832.638 832.35 839.884 822.033L839.896 822.045Z",
    fill: "white",
    stroke: "#716558",
    strokeWidth: 5.77038,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M656.492 183.044L381.385 16.543L17 242.691L415.564 475.27",
    stroke: "#F69320",
    strokeWidth: 17.2991,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M894.457 327.063L1239 535.601L870.416 719.197L850.37 729.91L647.207 611.347",
    stroke: "#F69320",
    strokeWidth: 17.2991,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M520.825 196.193C575.002 196.193 618.921 152.274 618.921 98.0964C618.921 43.9193 575.002 0 520.825 0C466.648 0 422.729 43.9193 422.729 98.0964C422.729 152.274 466.648 196.193 520.825 196.193Z",
    fill: "#F69320"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M894.816 386.735L893.904 325.408L956.299 320.729",
    stroke: "#F69320",
    strokeWidth: 17.2991,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M408.929 422.4L426.552 481.148L367.805 502.682",
    stroke: "#F69320",
    strokeWidth: 17.2991,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopLg);
export default __webpack_public_path__ + "static/media/desktop-lg.92fe2e52c508c6f3b0e1583b90721ee4.svg";
export { ForwardRef as ReactComponent };